import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import axios from "axios";

import { SYSTEM_PATH } from "../App";

// AJAX通信用クライアント生成
const AxiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});
export default AxiosClient;

export const SetupInterceptors = (navigate) => {
  // AJAX通信リクエスト送信時処理設定
  AxiosClient.interceptors.request.use(async (config) => {
    let token = sessionStorage.getItem("token");
    if (token != null) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  });

  // AJAX通信レスポンス受信時処理設定
  AxiosClient.interceptors.response.use(
    (response) => {
      // トークン更新
      if (response['headers'] !== undefined) {
        if (response.headers['refresh-token'] !== undefined) {
          // API通信用ヘッダにトークンをセット
          sessionStorage.setItem('token', response.headers['refresh-token']);
        }
      }

      if (response && response.data) {
        return response.data;
      }
      return response;
    },
    (error) => {
      // axiosの共通エラーハンドリング記述
      switch (error.response?.status) {
        // 認証エラー
        case 401:
          // トークンの削除
          sessionStorage.removeItem("token");
          // 利用者情報の削除
          sessionStorage.removeItem("userInfo");
          // ログイン画面に戻る
          navigate(SYSTEM_PATH);

          return Promise.reject(error);
          
        default:
          throw error;
      }
    }
  );
};
